import { Permission } from './permission.model';
import { PaymentMerchants } from './merchants.model';
import { DeviceType, DirectionTypeEnum } from './restaurant.model';

export class Company {
  id: number;
  title: string;
  hidden: boolean;
  permission: Permission;
  logo_url?: string;
  background_url?: string;
  mobile_background_url?: string;
  google_play?: string;
  app_store?: string;
  instagram_account!: string;
  currency!: string;
  delivery_available!: boolean;
  delivery_time!: number;
  transaction_fee: number;
  transaction_fees: TransactionFee[];
  default_payment_gateway!: PaymentMerchants;
  invoicePaymentAvailable!: boolean;

  constructor() {
    this.id = -1;
    this.title = '';
    this.hidden = false;
    this.transaction_fee = 0;
    this.permission = new Permission();
    this.transaction_fees = [];
  }
}

export interface TransactionFee {
  id?: number;
  company_id?: number;
  direction: DirectionTypeEnum;
  source: DeviceType;
  value: number;
}
